import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import SettingsSubMenu from '../containers/common/SettingsSubMenu';
import OrgUserHeader from '../containers/users/OrgUserHeader';
import OrgUserList from '../containers/users/OrgUserList';


export default function (children = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <div className="sett__cont">
            <SettingsSubMenu />

            <OrgUserHeader />
            <PageContentWrapper>
              <OrgUserList />
            </PageContentWrapper>
            {children}
          </div>
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
};
